(() => {
  const overlay = document.getElementById('SearchOverlay');
  if (!overlay) return;

  const form = overlay.querySelector('form.search-overlay__form');
  const input = overlay.querySelector('#SearchOverlayInput');
  const results = overlay.querySelector('#SearchOverlayResults');

  if (!form || !input || !results) return;

  const getQuery = () => input.value.trim();

  // IMPORTANT: this must match the section name used on your search template.
  // In Dawn this is usually "main-search".
  const SECTION_ID = 'main-search';

  async function renderResults(q) {
    // Build a Shopify search URL but request only the section HTML
    const url =
      `${window.routes?.search_url || '/search'}`
      + `?q=${encodeURIComponent(q)}`
      + `&options[prefix]=last`
      + `&sections=${encodeURIComponent(SECTION_ID)}`;

    const res = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
    if (!res.ok) throw new Error(`Search overlay fetch failed: ${res.status}`);

    const json = await res.json();
    const html = json[SECTION_ID];

    if (!html) {
      results.innerHTML = `<p>No results.</p>`;
    } else {
      // Insert the returned section HTML directly
      results.innerHTML = html;
    }

    results.removeAttribute('hidden');
    overlay.classList.add('search-overlay--show-results');
  }

  // Prevent navigation to /search
  form.addEventListener('submit', async (e) => {
    e.preventDefault();

    const q = getQuery();
    if (!q) return;

    try {
      await renderResults(q);
    } catch (err) {
      console.error(err);
    }
  });

  // If they click a predictive item, allow navigation (or you can intercept later)
  // This phase is only about preventing /search navigation for manual submit.
})();
